import * as React from 'react';
import { GiSpeaker, GiSpeakerOff } from 'react-icons/gi';
import classNames from 'styles/utils/classNames';

interface Props {
  isSoundEnabled: boolean;
  setIsSoundEnabled: (isSoundEnabled: boolean) => void;
  className?: string;
}

const SpeakerButton: React.FC<React.PropsWithChildren<Props>> = ({
  isSoundEnabled,
  setIsSoundEnabled,
  className,
}) => {
  return (
    <button
      type="button"
      aria-label="Flow sounds"
      aria-pressed={isSoundEnabled}
      className={classNames(
        'flex h-6 w-6 flex-shrink-0 items-center justify-center rounded bg-palette-border text-sm leading-none focus:outline-none',
        className,
      )}
      onClick={() => setIsSoundEnabled(!isSoundEnabled)}
    >
      {isSoundEnabled ? <GiSpeaker /> : <GiSpeakerOff />}
    </button>
  );
};

export default SpeakerButton;
